import { render, staticRenderFns } from "./ireviewsubmit.vue?vue&type=template&id=08117b5c&"
import script from "./ireviewsubmit.vue?vue&type=script&lang=js&"
export * from "./ireviewsubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports